import { render, staticRenderFns } from "./SpouseDetailForm.vue?vue&type=template&id=a2fc5e78"
import script from "./SpouseDetailForm.vue?vue&type=script&lang=js"
export * from "./SpouseDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports